import { FC } from "react";
import { ShareIssueModel } from "./increaseOfShareCapitalDomain";
import { observer } from "mobx-react";
import { Box } from "../../components-v2/Box";
import { Button, LinkButton } from "../../components-v2/Button";
import { Select } from "../../components-v2/Select";
import { useTranslation } from "../../stores/RootStoreContext";
import { shareTypeLabel } from "../../common/share";

const NewShareType: FC<{ model: ShareIssueModel }> = observer(({ model }) => {
  const { t } = useTranslation();
  if (!model.isAddNewSharetype) {
    return (
      <Box>
        <LinkButton
          label={t("decisions.increaseShareCapitalAgainstCash.addNewShareType")}
          icon={"plus"}
          disabled={model.isProjectLocked}
          onClick={() => model.openAddNewSharetype()}
        />
      </Box>
    );
  } else {
    return (
      <Box alignItems="center">
        <Select
          fullWidth={false}
          label={t("choose.sharetype")}
          idFn={(sharetypeCode) => sharetypeCode}
          labelFn={(sharetypeCode) => t(shareTypeLabel(sharetypeCode))}
          value={model.newSharetypeCode}
          items={model.shareTypeCodes}
          onSelect={(sharetypeCode) => model.setNewSharetypeCode(sharetypeCode)}
          error={!model.isValidNewSharetypeCode}
          message={t("choose.sharetypeError")}
          disabled={model.isProjectLocked}
        />
        <Box>
          <Button
            variant={"primary"}
            label={t("save")}
            onClick={(e) => {
              e.stopPropagation();
              model.submitNewShareType();
            }}
            disabled={model.isProjectLocked}
          />
          <Button
            label={t("cancel")}
            variant={"secondary"}
            onClick={(e) => {
              e.stopPropagation();
              model.clearNewShareType();
            }}
          />
        </Box>
      </Box>
    );
  }
});

export default NewShareType;
